import { useEffect, useState } from 'react';

/** Samma brytpunkt som App.tsx (`mob`): under 768 px räknas som mobil. */
export function useIsMobile(breakpoint = 768): boolean {
  const [mob, setMob] = useState(() => typeof window !== 'undefined' && window.innerWidth < breakpoint);
  useEffect(() => {
    const on = () => setMob(window.innerWidth < breakpoint);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, [breakpoint]);
  return mob;
}
